"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAll = getAll;
async function getAll(orderRepo, page = 1, pageSize = 10, filter, machineIds, clubIds, startDate = '', endDate = '', sort) {
    return await orderRepo.getAll(page, pageSize, filter, machineIds, clubIds, startDate, endDate, sort);
}
